import React, { useRef, useState } from 'react';
import { FieldError } from 'react-hook-form';
import Tooltip from 'react-tooltip-portal';
import DatePicker from 'react-datepicker';

interface IDateInputBaseProps {
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    error?: FieldError | string;
    helperTip?: string;
    inputRef?: React.Ref<HTMLInputElement>;
    isRequired?: boolean;
    name?: string;
    placeholder?: string;
    value?: Date;
    onChange?: (event: Date) => void;
    autoFocus?: boolean;
}

const DateInputBase: React.FC<IDateInputBaseProps> = (props) => {
    const tooltipRef = useRef(null);
    const wrapperRef = useRef(null);
    const [overTooltip, setOverTooltip] = useState(false);
    const [hasFocus, setHasFocus] = useState(false);

    let labelClass = 'label';
    labelClass += props.isRequired ? ' is-required' : '';
    labelClass += props.helperTip ? ' has-helper-tip' : '';

    // let inputClass = 'input';
    // if (props.error) { inputClass += ' has-error'; }

    const errorPanel = () => {
        if (props.error && typeof props.error === 'string') {
            return <div>{props.error}</div>;
        } else {
            return <div>{(props.error as FieldError)?.message}</div>;
        }
    };

    // const [currentDateString, setCurrentDateString] = useState(props.value?.toLocaleDateString());

    const onChange = (e: Date) => {
        // setCurrentDateString(e?.toLocaleDateString());

        if (props.onChange) {
            props.onChange(e);
        }
    };

    return (
        <div className="dlc-form-textbox-wrapper2" style={props.style} ref={wrapperRef}>
            {props.label && (
                <label className={labelClass} htmlFor={props.name}>
                    {props.helperTip && (
                        <span
                            className="tool-tip"
                            ref={tooltipRef}
                            onMouseEnter={() => setOverTooltip(true)}
                            onMouseLeave={() => setOverTooltip(false)}
                        >
                            <i className="fa fa-info-circle" />
                        </span>
                    )}
                    <Tooltip active={overTooltip} parent={tooltipRef.current} position="top" className="tooltip">
                        <div>{props.helperTip}</div>
                    </Tooltip>
                    <Tooltip
                        active={props.error && hasFocus}
                        parent={wrapperRef.current}
                        position="bottom"
                        className="form-validation-tooltip"
                        timeout={0}
                        hoverEvents={false}
                        tipStyle={{ pointerEvents: 'none' }}
                    >
                        {errorPanel()}
                    </Tooltip>
                    {props.label}
                </label>
            )}
            <DatePicker
                onChange={onChange}
                onFocus={() => setHasFocus(true)}
                isClearable={true}
                closeOnScroll={true}
                minDate={new Date('1/1/1980')}
                maxDate={new Date('12/31/2050')}
                showMonthDropdown={true}
                showYearDropdown={true}
                name={props.name}
                selected={props.value}
                enableTabLoop={false}
            />
            {/* <input
                    className={inputClass}
                    name={props.name}
                    id={props.name}
                    ref={props.inputRef}
                    placeholder={props.placeholder}
                    onFocus={() => setHasFocus(true)}
                    onBlur={() => setHasFocus(false)}
                    onChange={props.onChange}
                    autoFocus={props.autoFocus}
                /> */}
        </div>
    );
};

export default DateInputBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/DateInputBase.tsx